var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_c('strong',[_vm._v(" "+_vm._s(_vm.$t('company.welcome'))+" ")])])])],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }